/**
 * URL validation helpers for RichTextEditor (links, images).
 * Rejects dangerous schemes (javascript:, data:, vbscript:) and validates allowed schemes.
 */

const DANGEROUS_SCHEMES = /^(javascript|data|vbscript):/i;

/** Rejects javascript:, data:, vbscript: and similar. */
export function isDangerousUrl(url: string): boolean {
  if (!url || typeof url !== 'string') return true;
  return DANGEROUS_SCHEMES.test(url.trim());
}

/** Valid image URLs: https only, or Firebase Storage. */
export function isValidImageUrl(url: string): boolean {
  if (!url || typeof url !== 'string') return false;
  const trimmed = url.trim();
  if (isDangerousUrl(trimmed)) return false;
  return /^https:\/\//i.test(trimmed) || /firebasestorage\.googleapis\.com/i.test(trimmed);
}

/** Valid link URLs: https?, mailto, tel. */
export function isValidLinkUrl(url: string): boolean {
  if (!url || typeof url !== 'string') return false;
  const trimmed = url.trim();
  if (isDangerousUrl(trimmed)) return false;
  return /^(https?:\/\/|mailto:|tel:)/i.test(trimmed);
}
